module.exports = __webpack_public_path__ + "static/media/newsletter-november-2024-4.d66b26e2.jpg";